import HttpClient from './HttpClient';
import { OPINION_SERVICE_HOST, OPINIONS_API_PREFIX } from './RestConstants';
import { Comment, CreateCommentRequest } from '../interface/Comment';

export async function getComments(opinionId: string): Promise<{ comments: Comment[] }> {
  const response = await HttpClient.GET({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/opinions/${opinionId}/comments`,
  });

  return response.data;
}

export async function createComment(opinionId: string, commentData: CreateCommentRequest): Promise<Comment> {
  const response = await HttpClient.POST({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/opinions/${opinionId}/comments`,
    data: commentData,
  });

  return response.data;
}

export async function deleteComment(id: string, userId: string): Promise<void> {
  await HttpClient.DELETE({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/comments/${id}`,
    data: { userId },
  });
}
